"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _shippingMethodsSlice = require("@deosite/app/features/shippingMethods/shippingMethodsSlice");
var _useAppConfiguration2 = _interopRequireDefault(require("@deosite/app/features/appConfiguration/useAppConfiguration"));
var useShippingMethods = function useShippingMethods() {
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state.shippingMethods;
    }),
    shippingMethods = _useSelector.shippingMethods,
    selectedPickupPoint = _useSelector.selectedPickupPoint,
    pickedShippingMethod = _useSelector.pickedShippingMethod,
    pickupPoints = _useSelector.pickupPoints,
    selectedShippingMethod = _useSelector.selectedShippingMethod,
    loadingPickupPoints = _useSelector.loadingPickupPoints,
    loading = _useSelector.loading,
    inpostLockerChosen = _useSelector.inpostLockerChosen,
    dhlParcelChosen = _useSelector.dhlParcelChosen,
    shippingMethodsCountry = _useSelector.shippingMethodsCountry;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language,
    domain = _useAppConfiguration.domain;
  var dispatch = (0, _reactRedux.useDispatch)();
  var selectShippingMethod = function selectShippingMethod(type) {
    dispatch((0, _shippingMethodsSlice.setShippingMethod)(type));
  };
  var updatePickupPoint = function updatePickupPoint(type) {
    dispatch((0, _shippingMethodsSlice.setPickupPoint)(type));
  };
  var updateInpost = function updateInpost(detail) {
    dispatch((0, _shippingMethodsSlice.setInpostLockerChosen)(detail));
  };
  var updateDhl = function updateDhl(detail) {
    dispatch((0, _shippingMethodsSlice.setDhlParcelChosen)(detail));
  };
  var updateShipping = function updateShipping(_ref) {
    var token = _ref.token,
      cartId = _ref.cartId;
    dispatch((0, _shippingMethodsSlice.fetchShippingMethods)({
      token: token,
      language: language,
      domain: domain,
      cartId: cartId,
      country: language
    }));
  };
  return {
    shippingMethods: shippingMethods,
    selectShippingMethod: selectShippingMethod,
    pickupPoints: pickupPoints,
    updatePickupPoint: updatePickupPoint,
    selectedPickupPoint: selectedPickupPoint,
    pickedShippingMethod: pickedShippingMethod,
    selectedShippingMethod: selectedShippingMethod,
    updateInpost: updateInpost,
    inpostLockerChosen: inpostLockerChosen,
    loadingPickupPoints: loadingPickupPoints,
    loading: loading,
    dhlParcelChosen: dhlParcelChosen,
    updateDhl: updateDhl,
    shippingMethodsCountry: shippingMethodsCountry,
    updateShipping: updateShipping
  };
};
var _default = useShippingMethods;
exports["default"] = _default;